/**
 * ------------------------------------------------------------
 * Developer Name : Praveen Tripathi
 * Purpose        : Landing per-section error boundary wrapper
 * ------------------------------------------------------------
 */

"use client";

import { memo, type ReactNode } from "react";
import { SectionErrorBoundary } from "@/components/common/ErrorBoundary";

interface LandingPageSectionProps {
  section: string;
  children: ReactNode;
}

function LandingPageSectionBase({
  section,
  children,
}: LandingPageSectionProps) {
  return (
    <SectionErrorBoundary sectionName={`landing:${section}`}>
      {children}
    </SectionErrorBoundary>
  );
}

export const LandingPageSection = memo(LandingPageSectionBase);
LandingPageSection.displayName = "LandingPageSection";
